export const PassRailMainMobile = () => {
  return (
    <div
      style={{
        boxSizing: "border-box",
        backgroundColor: "rgb(243, 243, 248)",
        minHeight: "100%",
      }}
      className="lg:hidden"
    >
      <div
        style={{
          boxSizing: "border-box",
          padding: "0px",
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto",
          display: "block",
          paddingLeft: "0px",
          paddingRight: "0px",
          height: "auto",
        }}
      >
        <div
          style={{
            boxSizing: "border-box",
            display: "flex",
            flexFlow: "row wrap",
            width: "100%",
            WebkitBoxPack: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              boxSizing: "border-box",
              margin: "0px",
              flexDirection: "row",
              flexBasis: "100%",
              WebkitBoxFlex: 0,
              flexGrow: 0,
              maxWidth: "100%",
              padding: "0px 16px",
            }}
          >
            <div
              data-test="breadcrumb"
              style={{
                boxSizing: "border-box",
                margin: "0px 0px 0px",
                fontFamily: "Avenir",
                fontSize: "16px",
                lineHeight: "22px",
                fontWeight: 500,
                color: "rgb(94, 104, 120)",
                padding: "0px",
              }}
            >
              <ol
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexWrap: "wrap",
                  WebkitBoxAlign: "center",
                  alignItems: "center",
                  padding: "0px",
                  margin: "0px",
                  listStyle: "outside none none",
                }}
              >
                <li style={{ boxSizing: "border-box" }}>
                  <a
                    href="/app"
                    style={{
                      boxSizing: "border-box",
                      backgroundColor: "rgba(0, 0, 0, 0)",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      color: "rgb(20, 112, 138)",
                      textDecoration: "none solid rgb(20, 112, 138)",
                      cursor: "pointer",
                      position: "relative",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "inline-flex",
                      padding: "0px",
                    }}
                  >
                    Accueil
                  </a>
                </li>
                <li
                  aria-hidden="true"
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    userSelect: "none",
                    marginLeft: "8px",
                    marginRight: "8px",
                  }}
                >
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      boxSizing: "border-box",
                      height: "13px",
                      margin: "2px -8px 0px",
                      width: "1.25rem",
                    }}
                  >
                    <path
                      d="M8.79362 6.6659C8.36568 7.06175 8.36568 7.73825 8.79362 8.1341L12.973 12L8.79362 15.8659C8.36568 16.2617 8.36568 16.9383 8.79362 17.3341L8.83447 17.3719C9.21775 17.7264 9.80928 17.7264 10.1926 17.3719L15.2064 12.7341C15.6343 12.3383 15.6343 11.6617 15.2064 11.2659L10.1926 6.62811C9.80928 6.27358 9.21775 6.27358 8.83447 6.62811L8.79362 6.6659Z"
                      style={{ boxSizing: "border-box" }}
                    ></path>
                  </svg>
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <a
                    href="/app/offre"
                    style={{
                      boxSizing: "border-box",
                      backgroundColor: "rgba(0, 0, 0, 0)",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      color: "rgb(20, 112, 138)",
                      textDecoration: "none solid rgb(20, 112, 138)",
                      cursor: "pointer",
                      position: "relative",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "inline-flex",
                      padding: "0px",
                    }}
                  >
                    Offres
                  </a>
                </li>
                <li
                  aria-hidden="true"
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    userSelect: "none",
                    marginLeft: "8px",
                    marginRight: "8px",
                  }}
                >
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      boxSizing: "border-box",
                      height: "13px",
                      margin: "2px -8px 0px",
                      width: "1.25rem",
                    }}
                  >
                    <path
                      d="M8.79362 6.6659C8.36568 7.06175 8.36568 7.73825 8.79362 8.1341L12.973 12L8.79362 15.8659C8.36568 16.2617 8.36568 16.9383 8.79362 17.3341L8.83447 17.3719C9.21775 17.7264 9.80928 17.7264 10.1926 17.3719L15.2064 12.7341C15.6343 12.3383 15.6343 11.6617 15.2064 11.2659L10.1926 6.62811C9.80928 6.27358 9.21775 6.27358 8.83447 6.62811L8.79362 6.6659Z"
                      style={{ boxSizing: "border-box" }}
                    ></path>
                  </svg>
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <p
                    aria-current="page"
                    style={{
                      boxSizing: "border-box",
                      margin: "2px 0px 0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      color: "rgb(12, 19, 31)",
                    }}
                  >
                    Découvrez le Pass Rail
                  </p>
                </li>
              </ol>
            </div>
            <div
              style={{
                boxSizing: "border-box",
                WebkitBoxAlign: "center",
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                marginTop: "40px",
                paddingBottom: "16px",
              }}
            >
              <div
                style={{
                  boxSizing: "border-box",
                  alignSelf: "start",
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "32px",
                }}
              >
                <h2
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0px 16px",
                    fontFamily: "Avenir",
                    fontSize: "20px",
                    lineHeight: "26px",
                    fontWeight: 800,
                  }}
                >
                  Découvrez le Pass Rail
                </h2>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px",
                    fontFamily: "Avenir",
                    fontSize: "16px",
                    lineHeight: "22px",
                    fontWeight: 500,
                    whiteSpace: "pre-line",
                  }}
                >
                  Pour seulement 2,45 €/mois, voyagez en illimité sur les réseaux
                  INTERCITÉS et Trains Régionaux !
                </p>
              </div>
              <ul
                style={{
                  boxSizing: "border-box",
                  alignSelf: "start",
                  display: "flex",
                  flexDirection: "column",
                  listStyleType: "none",
                  margin: "0px",
                  padding: "0px",
                }}
              >
                <li
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexFlow: "row nowrap",
                    marginBottom: "16px",
                  }}
                >
                  <div style={{ boxSizing: "border-box" }}>
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      data-test="majorAvantages-0"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(12, 19, 31)",
                        marginRight: "16px",
                        height: "24px",
                        width: "24px",
                      }}
                    >
                      <path
                        d="M2.11377 19.4238C2.11373 19.3582 2.12664 19.2931 2.15175 19.2324C2.17687 19.1718 2.21369 19.1166 2.26013 19.0702C2.30657 19.0238 2.3617 18.9869 2.42238 18.9618C2.48306 18.9367 2.5481 18.9238 2.61377 18.9238H4.48486C5.53557 18.9234 6.5499 19.3086 7.33545 20.0063L7.51904 20.1694C8.12172 20.7048 8.89993 21.0003 9.70605 21H16.4829C16.7511 21 17.0083 20.8935 17.198 20.7038C17.3876 20.5142 17.4941 20.257 17.4941 19.9888C17.4941 19.7206 17.3876 19.4634 17.198 19.2737C17.0083 19.0841 16.7511 18.9775 16.4829 18.9775C16.3503 18.9775 16.2231 18.9249 16.1294 18.8311C16.0356 18.7373 15.9829 18.6101 15.9829 18.4775C15.9829 18.3449 16.0356 18.2178 16.1294 18.124C16.2231 18.0302 16.3503 17.9775 16.4829 17.9775H17.625C17.8933 17.9775 18.1505 17.871 18.3402 17.6813C18.5299 17.4916 18.6365 17.2343 18.6365 16.966C18.6365 16.6978 18.5299 16.4405 18.3402 16.2508C18.1505 16.0611 17.8933 15.9545 17.625 15.9545C17.4924 15.9545 17.3652 15.9019 17.2714 15.8081C17.1777 15.7143 17.125 15.5871 17.125 15.4545C17.125 15.3219 17.1777 15.1948 17.2714 15.101C17.3652 15.0072 17.4924 14.9545 17.625 14.9545C17.6759 14.9545 17.7238 14.9659 17.7737 14.9696C17.8074 14.9588 17.8422 14.9518 17.8774 14.9487H18.5703C18.8385 14.9487 19.0957 14.8421 19.2854 14.6525C19.475 14.4629 19.5815 14.2056 19.5815 13.9375C19.5815 13.6693 19.475 13.412 19.2854 13.2224C19.0957 13.0328 18.8385 12.9262 18.5703 12.9262C18.4377 12.9262 18.3105 12.8735 18.2168 12.7798C18.123 12.686 18.0703 12.5588 18.0703 12.4262C18.0703 12.2936 18.123 12.1664 18.2168 12.0727C18.3105 11.9789 18.4377 11.9262 18.5703 11.9262H19.875C20.1427 11.9254 20.3992 11.8184 20.5882 11.6288C20.7772 11.4392 20.8833 11.1825 20.8833 10.9147C20.8833 10.647 20.7772 10.3902 20.5882 10.2006C20.3992 10.011 20.1427 9.90411 19.875 9.90327H11.8501C11.7175 9.90327 11.5903 9.85059 11.4965 9.75682C11.4028 9.66306 11.3501 9.53588 11.3501 9.40327C11.3501 9.27066 11.4028 9.14349 11.4965 9.04972C11.5903 8.95595 11.7175 8.90327 11.8501 8.90327H12.4595L12.9727 4.41011C12.9588 4.03012 12.7976 3.67043 12.5232 3.40723C12.2488 3.14402 11.8827 2.99797 11.5024 3H10.3364C10.2973 3.00019 10.2593 3.01291 10.2279 3.03628C10.1966 3.05965 10.1735 3.09245 10.1621 3.12988L8.59131 8.35742C8.44535 8.85127 8.14303 9.2844 7.7298 9.5917C7.31657 9.899 6.81476 10.0639 6.2998 10.0615H3.26318C3.13057 10.0615 3.00339 10.0088 2.90963 9.91507C2.81586 9.82131 2.76318 9.69413 2.76318 9.56152C2.76318 9.42891 2.81586 9.30173 2.90963 9.20797C3.00339 9.1142 3.13057 9.06152 3.26318 9.06152H6.2998C6.59949 9.06295 6.89154 8.96703 7.13203 8.78818C7.37251 8.60934 7.54842 8.35725 7.6333 8.06982L9.2041 2.84229C9.27824 2.59943 9.42815 2.38667 9.63189 2.23512C9.83563 2.08357 10.0825 2.00118 10.3364 2H11.5024C12.1565 2.00069 12.7835 2.2608 13.246 2.72327C13.7084 3.18573 13.9685 3.81278 13.9692 4.4668L13.4653 8.90332H19.875C20.3735 8.90337 20.8542 9.08851 21.2239 9.42286C21.5937 9.75721 21.8261 10.2169 21.8761 10.7129C21.9261 11.2089 21.7902 11.7058 21.4946 12.1072C21.1991 12.5086 20.765 12.786 20.2766 12.8856C20.4346 13.1372 20.5343 13.4209 20.5684 13.716C20.6025 14.0111 20.5701 14.3101 20.4737 14.5911C20.3772 14.8721 20.2191 15.1279 20.0109 15.3398C19.8027 15.5518 19.5497 15.7144 19.2705 15.8159C19.4556 16.0779 19.5748 16.3807 19.618 16.6986C19.6613 17.0165 19.6273 17.3401 19.519 17.6421C19.4106 17.9441 19.2312 18.2155 18.9957 18.4335C18.7603 18.6514 18.4758 18.8094 18.1664 18.8941C18.365 19.1971 18.4778 19.5482 18.4929 19.9101C18.508 20.2721 18.4248 20.6313 18.2522 20.9498C18.0796 21.2683 17.824 21.5341 17.5124 21.719C17.2009 21.9039 16.8452 22.001 16.4829 22H9.70605C8.6552 22.0005 7.64073 21.6153 6.855 20.9175L6.67141 20.7544C6.06887 20.2191 5.29084 19.9236 4.48488 19.9238H2.61377C2.5481 19.9239 2.48306 19.911 2.42238 19.8858C2.3617 19.8607 2.30657 19.8239 2.26013 19.7775C2.21369 19.731 2.17687 19.6759 2.15175 19.6152C2.12664 19.5545 2.11373 19.4895 2.11377 19.4238Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </div>
                  <p
                    aria-hidden="true"
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "18px",
                      lineHeight: "24px",
                      fontWeight: 800,
                      maxWidth: "300px",
                    }}
                  >
                    Pour les 16 - 27 ans (jusqu'à la veille des 28 ans)
                  </p>
                  <span
                    style={{
                      boxSizing: "border-box",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                      border: "0px none rgb(12, 19, 31)",
                      clip: "rect(0px, 0px, 0px, 0px)",
                      height: "1px",
                      margin: "-1px",
                      overflow: "hidden",
                      padding: "0px",
                      position: "absolute",
                      whiteSpace: "nowrap",
                      width: "1px",
                    }}
                  >
                    Pour les 16 - 27 ans (jusqu'à la veille des 28 ans)
                  </span>
                </li>
                <li
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexFlow: "row nowrap",
                    marginBottom: "16px",
                  }}
                >
                  <div style={{ boxSizing: "border-box" }}>
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      data-test="majorAvantages-1"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(12, 19, 31)",
                        marginRight: "16px",
                        height: "24px",
                        width: "24px",
                      }}
                    >
                      <path
                        d="M2.11377 19.4238C2.11373 19.3582 2.12664 19.2931 2.15175 19.2324C2.17687 19.1718 2.21369 19.1166 2.26013 19.0702C2.30657 19.0238 2.3617 18.9869 2.42238 18.9618C2.48306 18.9367 2.5481 18.9238 2.61377 18.9238H4.48486C5.53557 18.9234 6.5499 19.3086 7.33545 20.0063L7.51904 20.1694C8.12172 20.7048 8.89993 21.0003 9.70605 21H16.4829C16.7511 21 17.0083 20.8935 17.198 20.7038C17.3876 20.5142 17.4941 20.257 17.4941 19.9888C17.4941 19.7206 17.3876 19.4634 17.198 19.2737C17.0083 19.0841 16.7511 18.9775 16.4829 18.9775C16.3503 18.9775 16.2231 18.9249 16.1294 18.8311C16.0356 18.7373 15.9829 18.6101 15.9829 18.4775C15.9829 18.3449 16.0356 18.2178 16.1294 18.124C16.2231 18.0302 16.3503 17.9775 16.4829 17.9775H17.625C17.8933 17.9775 18.1505 17.871 18.3402 17.6813C18.5299 17.4916 18.6365 17.2343 18.6365 16.966C18.6365 16.6978 18.5299 16.4405 18.3402 16.2508C18.1505 16.0611 17.8933 15.9545 17.625 15.9545C17.4924 15.9545 17.3652 15.9019 17.2714 15.8081C17.1777 15.7143 17.125 15.5871 17.125 15.4545C17.125 15.3219 17.1777 15.1948 17.2714 15.101C17.3652 15.0072 17.4924 14.9545 17.625 14.9545C17.6759 14.9545 17.7238 14.9659 17.7737 14.9696C17.8074 14.9588 17.8422 14.9518 17.8774 14.9487H18.5703C18.8385 14.9487 19.0957 14.8421 19.2854 14.6525C19.475 14.4629 19.5815 14.2056 19.5815 13.9375C19.5815 13.6693 19.475 13.412 19.2854 13.2224C19.0957 13.0328 18.8385 12.9262 18.5703 12.9262C18.4377 12.9262 18.3105 12.8735 18.2168 12.7798C18.123 12.686 18.0703 12.5588 18.0703 12.4262C18.0703 12.2936 18.123 12.1664 18.2168 12.0727C18.3105 11.9789 18.4377 11.9262 18.5703 11.9262H19.875C20.1427 11.9254 20.3992 11.8184 20.5882 11.6288C20.7772 11.4392 20.8833 11.1825 20.8833 10.9147C20.8833 10.647 20.7772 10.3902 20.5882 10.2006C20.3992 10.011 20.1427 9.90411 19.875 9.90327H11.8501C11.7175 9.90327 11.5903 9.85059 11.4965 9.75682C11.4028 9.66306 11.3501 9.53588 11.3501 9.40327C11.3501 9.27066 11.4028 9.14349 11.4965 9.04972C11.5903 8.95595 11.7175 8.90327 11.8501 8.90327H12.4595L12.9727 4.41011C12.9588 4.03012 12.7976 3.67043 12.5232 3.40723C12.2488 3.14402 11.8827 2.99797 11.5024 3H10.3364C10.2973 3.00019 10.2593 3.01291 10.2279 3.03628C10.1966 3.05965 10.1735 3.09245 10.1621 3.12988L8.59131 8.35742C8.44535 8.85127 8.14303 9.2844 7.7298 9.5917C7.31657 9.899 6.81476 10.0639 6.2998 10.0615H3.26318C3.13057 10.0615 3.00339 10.0088 2.90963 9.91507C2.81586 9.82131 2.76318 9.69413 2.76318 9.56152C2.76318 9.42891 2.81586 9.30173 2.90963 9.20797C3.00339 9.1142 3.13057 9.06152 3.26318 9.06152H6.2998C6.59949 9.06295 6.89154 8.96703 7.13203 8.78818C7.37251 8.60934 7.54842 8.35725 7.6333 8.06982L9.2041 2.84229C9.27824 2.59943 9.42815 2.38667 9.63189 2.23512C9.83563 2.08357 10.0825 2.00118 10.3364 2H11.5024C12.1565 2.00069 12.7835 2.2608 13.246 2.72327C13.7084 3.18573 13.9685 3.81278 13.9692 4.4668L13.4653 8.90332H19.875C20.3735 8.90337 20.8542 9.08851 21.2239 9.42286C21.5937 9.75721 21.8261 10.2169 21.8761 10.7129C21.9261 11.2089 21.7902 11.7058 21.4946 12.1072C21.1991 12.5086 20.765 12.786 20.2766 12.8856C20.4346 13.1372 20.5343 13.4209 20.5684 13.716C20.6025 14.0111 20.5701 14.3101 20.4737 14.5911C20.3772 14.8721 20.2191 15.1279 20.0109 15.3398C19.8027 15.5518 19.5497 15.7144 19.2705 15.8159C19.4556 16.0779 19.5748 16.3807 19.618 16.6986C19.6613 17.0165 19.6273 17.3401 19.519 17.6421C19.4106 17.9441 19.2312 18.2155 18.9957 18.4335C18.7603 18.6514 18.4758 18.8094 18.1664 18.8941C18.365 19.1971 18.4778 19.5482 18.4929 19.9101C18.508 20.2721 18.4248 20.6313 18.2522 20.9498C18.0796 21.2683 17.824 21.5341 17.5124 21.719C17.2009 21.9039 16.8452 22.001 16.4829 22H9.70605C8.6552 22.0005 7.64073 21.6153 6.855 20.9175L6.67141 20.7544C6.06887 20.2191 5.29084 19.9236 4.48488 19.9238H2.61377C2.5481 19.9239 2.48306 19.911 2.42238 19.8858C2.3617 19.8607 2.30657 19.8239 2.26013 19.7775C2.21369 19.731 2.17687 19.6759 2.15175 19.6152C2.12664 19.5545 2.11373 19.4895 2.11377 19.4238Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </div>
                  <p
                    aria-hidden="true"
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "18px",
                      lineHeight: "24px",
                      fontWeight: 800,
                      maxWidth: "300px",
                    }}
                  >
                    Pour des voyages du 01/07 au 31/08 inclus
                  </p>
                  <span
                    style={{
                      boxSizing: "border-box",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                      border: "0px none rgb(12, 19, 31)",
                      clip: "rect(0px, 0px, 0px, 0px)",
                      height: "1px",
                      margin: "-1px",
                      overflow: "hidden",
                      padding: "0px",
                      position: "absolute",
                      whiteSpace: "nowrap",
                      width: "1px",
                    }}
                  >
                    Pour des voyages du 01/07 au 31/08 inclus
                  </span>
                </li>
                <li
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexFlow: "row nowrap",
                    marginBottom: "16px",
                  }}
                >
                  <div style={{ boxSizing: "border-box" }}>
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      data-test="majorAvantages-2"
                      style={{
                        boxSizing: "border-box",
                        fill: "rgb(12, 19, 31)",
                        marginRight: "16px",
                        height: "24px",
                        width: "24px",
                      }}
                    >
                      <path
                        d="M2.11377 19.4238C2.11373 19.3582 2.12664 19.2931 2.15175 19.2324C2.17687 19.1718 2.21369 19.1166 2.26013 19.0702C2.30657 19.0238 2.3617 18.9869 2.42238 18.9618C2.48306 18.9367 2.5481 18.9238 2.61377 18.9238H4.48486C5.53557 18.9234 6.5499 19.3086 7.33545 20.0063L7.51904 20.1694C8.12172 20.7048 8.89993 21.0003 9.70605 21H16.4829C16.7511 21 17.0083 20.8935 17.198 20.7038C17.3876 20.5142 17.4941 20.257 17.4941 19.9888C17.4941 19.7206 17.3876 19.4634 17.198 19.2737C17.0083 19.0841 16.7511 18.9775 16.4829 18.9775C16.3503 18.9775 16.2231 18.9249 16.1294 18.8311C16.0356 18.7373 15.9829 18.6101 15.9829 18.4775C15.9829 18.3449 16.0356 18.2178 16.1294 18.124C16.2231 18.0302 16.3503 17.9775 16.4829 17.9775H17.625C17.8933 17.9775 18.1505 17.871 18.3402 17.6813C18.5299 17.4916 18.6365 17.2343 18.6365 16.966C18.6365 16.6978 18.5299 16.4405 18.3402 16.2508C18.1505 16.0611 17.8933 15.9545 17.625 15.9545C17.4924 15.9545 17.3652 15.9019 17.2714 15.8081C17.1777 15.7143 17.125 15.5871 17.125 15.4545C17.125 15.3219 17.1777 15.1948 17.2714 15.101C17.3652 15.0072 17.4924 14.9545 17.625 14.9545C17.6759 14.9545 17.7238 14.9659 17.7737 14.9696C17.8074 14.9588 17.8422 14.9518 17.8774 14.9487H18.5703C18.8385 14.9487 19.0957 14.8421 19.2854 14.6525C19.475 14.4629 19.5815 14.2056 19.5815 13.9375C19.5815 13.6693 19.475 13.412 19.2854 13.2224C19.0957 13.0328 18.8385 12.9262 18.5703 12.9262C18.4377 12.9262 18.3105 12.8735 18.2168 12.7798C18.123 12.686 18.0703 12.5588 18.0703 12.4262C18.0703 12.2936 18.123 12.1664 18.2168 12.0727C18.3105 11.9789 18.4377 11.9262 18.5703 11.9262H19.875C20.1427 11.9254 20.3992 11.8184 20.5882 11.6288C20.7772 11.4392 20.8833 11.1825 20.8833 10.9147C20.8833 10.647 20.7772 10.3902 20.5882 10.2006C20.3992 10.011 20.1427 9.90411 19.875 9.90327H11.8501C11.7175 9.90327 11.5903 9.85059 11.4965 9.75682C11.4028 9.66306 11.3501 9.53588 11.3501 9.40327C11.3501 9.27066 11.4028 9.14349 11.4965 9.04972C11.5903 8.95595 11.7175 8.90327 11.8501 8.90327H12.4595L12.9727 4.41011C12.9588 4.03012 12.7976 3.67043 12.5232 3.40723C12.2488 3.14402 11.8827 2.99797 11.5024 3H10.3364C10.2973 3.00019 10.2593 3.01291 10.2279 3.03628C10.1966 3.05965 10.1735 3.09245 10.1621 3.12988L8.59131 8.35742C8.44535 8.85127 8.14303 9.2844 7.7298 9.5917C7.31657 9.899 6.81476 10.0639 6.2998 10.0615H3.26318C3.13057 10.0615 3.00339 10.0088 2.90963 9.91507C2.81586 9.82131 2.76318 9.69413 2.76318 9.56152C2.76318 9.42891 2.81586 9.30173 2.90963 9.20797C3.00339 9.1142 3.13057 9.06152 3.26318 9.06152H6.2998C6.59949 9.06295 6.89154 8.96703 7.13203 8.78818C7.37251 8.60934 7.54842 8.35725 7.6333 8.06982L9.2041 2.84229C9.27824 2.59943 9.42815 2.38667 9.63189 2.23512C9.83563 2.08357 10.0825 2.00118 10.3364 2H11.5024C12.1565 2.00069 12.7835 2.2608 13.246 2.72327C13.7084 3.18573 13.9685 3.81278 13.9692 4.4668L13.4653 8.90332H19.875C20.3735 8.90337 20.8542 9.08851 21.2239 9.42286C21.5937 9.75721 21.8261 10.2169 21.8761 10.7129C21.9261 11.2089 21.7902 11.7058 21.4946 12.1072C21.1991 12.5086 20.765 12.786 20.2766 12.8856C20.4346 13.1372 20.5343 13.4209 20.5684 13.716C20.6025 14.0111 20.5701 14.3101 20.4737 14.5911C20.3772 14.8721 20.2191 15.1279 20.0109 15.3398C19.8027 15.5518 19.5497 15.7144 19.2705 15.8159C19.4556 16.0779 19.5748 16.3807 19.618 16.6986C19.6613 17.0165 19.6273 17.3401 19.519 17.6421C19.4106 17.9441 19.2312 18.2155 18.9957 18.4335C18.7603 18.6514 18.4758 18.8094 18.1664 18.8941C18.365 19.1971 18.4778 19.5482 18.4929 19.9101C18.508 20.2721 18.4248 20.6313 18.2522 20.9498C18.0796 21.2683 17.824 21.5341 17.5124 21.719C17.2009 21.9039 16.8452 22.001 16.4829 22H9.70605C8.6552 22.0005 7.64073 21.6153 6.855 20.9175L6.67141 20.7544C6.06887 20.2191 5.29084 19.9236 4.48488 19.9238H2.61377C2.5481 19.9239 2.48306 19.911 2.42238 19.8858C2.3617 19.8607 2.30657 19.8239 2.26013 19.7775C2.21369 19.731 2.17687 19.6759 2.15175 19.6152C2.12664 19.5545 2.11373 19.4895 2.11377 19.4238Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                  </div>
                  <p
                    aria-hidden="true"
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "18px",
                      lineHeight: "24px",
                      fontWeight: 800,
                      maxWidth: "300px",
                    }}
                  >
                    Abonnement valable 31 jours consécutifs
                  </p>
                  <span
                    style={{
                      boxSizing: "border-box",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                      border: "0px none rgb(12, 19, 31)",
                      clip: "rect(0px, 0px, 0px, 0px)",
                      height: "1px",
                      margin: "-1px",
                      overflow: "hidden",
                      padding: "0px",
                      position: "absolute",
                      whiteSpace: "nowrap",
                      width: "1px",
                    }}
                  >
                    Abonnement valable 31 jours consécutifs
                  </span>
                </li>
              </ul>
            </div>
            <hr
              aria-hidden="true"
              style={{
                boxSizing: "content-box",
                height: "8px",
                overflow: "visible",
                margin: "0px",
                flexShrink: 0,
                borderWidth: "0px",
                borderColor: "rgb(173, 255, 47)",
                backgroundColor: "rgb(255, 255, 255)",
                borderStyle: "none",
              }}
            />
            <div style={{ boxSizing: "border-box", marginTop: "32px" }}>
              <div
                data-test="avantagesBlock"
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  margin: "32px 0px 24px",
                }}
              >
                <h2
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0px 24px",
                    fontFamily: "Avenir",
                    fontSize: "20px",
                    lineHeight: "26px",
                    fontWeight: 800,
                  }}
                >
                  L'abonnement estival pour les jeunes
                </h2>
                <div
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ boxSizing: "border-box", flexShrink: 0 }}>
                    <div
                      style={{
                        display: "block",
                        boxSizing: "border-box",
                        height: "197.422px",
                        width: "100%",
                      }}
                    >
                      <img
                        alt=""
                        src="https://www.sncf-connect.com/assets/styles/scale_and_crop_328x218/public/media/2024-06/308x164_pass_rail.jpg?itok=eEyEPats"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          borderRadius: "24px",
                          height: "191.406px",
                          width: "100%",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "none",
                        boxSizing: "border-box",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <img
                        alt=""
                        src="https://www.sncf-connect.com/assets/styles/scale_and_crop_410x218/public/media/2024-06/308x164_pass_rail.jpg?itok=hY1ul22B"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          borderRadius: "24px",
                          height: "100%",
                          width: "100%",
                        }}
                      />
                    </div>
                  </div>
                  <ul
                    role="list"
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      flexFlow: "column wrap",
                      WebkitBoxPack: "justify",
                      justifyContent: "space-between",
                      listStyle: "outside none none",
                      margin: "0px 0px 0px",
                      padding: "0px",
                    }}
                  >
                    <li
                      style={{
                        boxSizing: "border-box",
                        gridArea: "content1",
                        alignSelf: "start",
                        display: "flex",
                        flexFlow: "row nowrap",
                        margin: "0px 0px 24px",
                        padding: "0px",
                      }}
                    >
                      <div style={{ boxSizing: "border-box" }}>
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          data-test="iconAvantages"
                          style={{
                            boxSizing: "border-box",
                            marginRight: "16px",
                            height: "20px",
                            width: "20px",
                          }}
                        >
                          <path
                            d="M21.5766 9.26017L15.4544 8.32781C15.3966 8.31763 15.3421 8.29341 15.2958 8.25727C15.2494 8.22112 15.2127 8.17416 15.1887 8.12051L12.4505 2.30782C12.4052 2.22824 12.3397 2.16207 12.2605 2.11605C12.1814 2.07002 12.0915 2.04578 11.9999 2.04578C11.9084 2.04578 11.8184 2.07002 11.7393 2.11605C11.6601 2.16207 11.5946 2.22824 11.5493 2.30782L8.81061 8.12099C8.78687 8.17446 8.75035 8.22129 8.70428 8.25735C8.65821 8.29341 8.60398 8.31761 8.54637 8.32781L2.42322 9.26017C2.3326 9.27397 2.24756 9.31251 2.17743 9.37153C2.1073 9.43055 2.05481 9.50777 2.02573 9.5947C1.99666 9.68162 1.99212 9.77488 2.01263 9.86422C2.03313 9.95356 2.07788 10.0355 2.14195 10.1011L6.57264 14.6257C6.61766 14.673 6.65097 14.7302 6.66989 14.7928C6.68882 14.8553 6.69284 14.9214 6.68164 14.9858L5.6354 21.3746C5.62376 21.4459 5.62777 21.5189 5.64714 21.5886C5.6665 21.6582 5.70077 21.7228 5.74757 21.7778C5.79436 21.8329 5.85256 21.8772 5.91815 21.9075C5.98373 21.9379 6.05513 21.9536 6.1274 21.9537C6.21153 21.9538 6.2943 21.9324 6.36779 21.8914L11.8437 18.8753C11.8914 18.8488 11.945 18.8348 11.9996 18.8347C12.0541 18.8345 12.1078 18.8481 12.1557 18.8743L17.6321 21.8914C17.714 21.9365 17.8069 21.9577 17.9002 21.9526C17.9936 21.9474 18.0836 21.9161 18.16 21.8622C18.2364 21.8083 18.2961 21.734 18.3323 21.6477C18.3684 21.5615 18.3796 21.4668 18.3645 21.3746L17.3182 14.9847C17.3071 14.9205 17.3111 14.8545 17.3302 14.7921C17.3492 14.7298 17.3826 14.6727 17.4277 14.6256L21.8579 10.101C21.922 10.0355 21.9667 9.95353 21.9872 9.86419C22.0077 9.77485 22.0032 9.68159 21.9741 9.59467C21.945 9.50774 21.8926 9.43052 21.8224 9.3715C21.7523 9.31248 21.6673 9.27394 21.5766 9.26014L21.5766 9.26017ZM16.7158 13.9283C16.5614 14.0874 16.4464 14.2804 16.3803 14.492C16.3141 14.7035 16.2985 14.9277 16.3348 15.1463L17.2151 20.524L12.6359 18.0013C12.441 17.8939 12.2221 17.8377 11.9995 17.8379C11.777 17.838 11.5581 17.8946 11.3634 18.0023L6.7848 20.524L7.66559 15.1463C7.70161 14.9278 7.68596 14.7038 7.61988 14.4924C7.5538 14.281 7.43913 14.088 7.28505 13.9288L3.53466 10.0986L8.69674 9.31273C8.91611 9.27812 9.12356 9.18994 9.30071 9.05599C9.47786 8.92205 9.61923 8.74648 9.71231 8.54484L11.9999 3.68934L14.2875 8.54534C14.3809 8.74693 14.5224 8.92242 14.6998 9.05627C14.8771 9.19012 15.0846 9.2782 15.3041 9.31274L20.4652 10.0986L16.7158 13.9283Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                      <div
                        style={{ boxSizing: "border-box", maxWidth: "370px" }}
                      >
                        <h3
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 4px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Un abonnement mensuel à 2,45 €*
                        </h3>
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Utilisable pendant 31 jours consécutifs à partir de la
                          date d'activation
                        </p>
                      </div>
                    </li>
                    <li
                      style={{
                        boxSizing: "border-box",
                        gridArea: "content2",
                        alignSelf: "start",
                        display: "flex",
                        flexFlow: "row nowrap",
                        margin: "0px 0px 24px",
                        padding: "0px",
                      }}
                    >
                      <div style={{ boxSizing: "border-box" }}>
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          data-test="iconAvantages"
                          style={{
                            boxSizing: "border-box",
                            marginRight: "16px",
                            height: "20px",
                            width: "20px",
                          }}
                        >
                          <path
                            d="M21.5766 9.26017L15.4544 8.32781C15.3966 8.31763 15.3421 8.29341 15.2958 8.25727C15.2494 8.22112 15.2127 8.17416 15.1887 8.12051L12.4505 2.30782C12.4052 2.22824 12.3397 2.16207 12.2605 2.11605C12.1814 2.07002 12.0915 2.04578 11.9999 2.04578C11.9084 2.04578 11.8184 2.07002 11.7393 2.11605C11.6601 2.16207 11.5946 2.22824 11.5493 2.30782L8.81061 8.12099C8.78687 8.17446 8.75035 8.22129 8.70428 8.25735C8.65821 8.29341 8.60398 8.31761 8.54637 8.32781L2.42322 9.26017C2.3326 9.27397 2.24756 9.31251 2.17743 9.37153C2.1073 9.43055 2.05481 9.50777 2.02573 9.5947C1.99666 9.68162 1.99212 9.77488 2.01263 9.86422C2.03313 9.95356 2.07788 10.0355 2.14195 10.1011L6.57264 14.6257C6.61766 14.673 6.65097 14.7302 6.66989 14.7928C6.68882 14.8553 6.69284 14.9214 6.68164 14.9858L5.6354 21.3746C5.62376 21.4459 5.62777 21.5189 5.64714 21.5886C5.6665 21.6582 5.70077 21.7228 5.74757 21.7778C5.79436 21.8329 5.85256 21.8772 5.91815 21.9075C5.98373 21.9379 6.05513 21.9536 6.1274 21.9537C6.21153 21.9538 6.2943 21.9324 6.36779 21.8914L11.8437 18.8753C11.8914 18.8488 11.945 18.8348 11.9996 18.8347C12.0541 18.8345 12.1078 18.8481 12.1557 18.8743L17.6321 21.8914C17.714 21.9365 17.8069 21.9577 17.9002 21.9526C17.9936 21.9474 18.0836 21.9161 18.16 21.8622C18.2364 21.8083 18.2961 21.734 18.3323 21.6477C18.3684 21.5615 18.3796 21.4668 18.3645 21.3746L17.3182 14.9847C17.3071 14.9205 17.3111 14.8545 17.3302 14.7921C17.3492 14.7298 17.3826 14.6727 17.4277 14.6256L21.8579 10.101C21.922 10.0355 21.9667 9.95353 21.9872 9.86419C22.0077 9.77485 22.0032 9.68159 21.9741 9.59467C21.945 9.50774 21.8926 9.43052 21.8224 9.3715C21.7523 9.31248 21.6673 9.27394 21.5766 9.26014L21.5766 9.26017ZM16.7158 13.9283C16.5614 14.0874 16.4464 14.2804 16.3803 14.492C16.3141 14.7035 16.2985 14.9277 16.3348 15.1463L17.2151 20.524L12.6359 18.0013C12.441 17.8939 12.2221 17.8377 11.9995 17.8379C11.777 17.838 11.5581 17.8946 11.3634 18.0023L6.7848 20.524L7.66559 15.1463C7.70161 14.9278 7.68596 14.7038 7.61988 14.4924C7.5538 14.281 7.43913 14.088 7.28505 13.9288L3.53466 10.0986L8.69674 9.31273C8.91611 9.27812 9.12356 9.18994 9.30071 9.05599C9.47786 8.92205 9.61923 8.74648 9.71231 8.54484L11.9999 3.68934L14.2875 8.54534C14.3809 8.74693 14.5224 8.92242 14.6998 9.05627C14.8771 9.19012 15.0846 9.2782 15.3041 9.31274L20.4652 10.0986L16.7158 13.9283Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                      <div
                        style={{ boxSizing: "border-box", maxWidth: "370px" }}
                      >
                        <h3
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 4px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Billets à 0 €
                        </h3>
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Sur les Trains Régionaux et INTERCITÉS Jour &amp; Nuit
                          (place assise) et à 19,50 € en couchette 2nde classe
                        </p>
                      </div>
                    </li>
                    <li
                      style={{
                        boxSizing: "border-box",
                        gridArea: "content3",
                        alignSelf: "start",
                        display: "flex",
                        flexFlow: "row nowrap",
                        margin: "0px 0px 24px",
                        padding: "0px",
                      }}
                    >
                      <div style={{ boxSizing: "border-box" }}>
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          data-test="iconAvantages"
                          style={{
                            boxSizing: "border-box",
                            marginRight: "16px",
                            height: "20px",
                            width: "20px",
                          }}
                        >
                          <path
                            d="M21.5766 9.26017L15.4544 8.32781C15.3966 8.31763 15.3421 8.29341 15.2958 8.25727C15.2494 8.22112 15.2127 8.17416 15.1887 8.12051L12.4505 2.30782C12.4052 2.22824 12.3397 2.16207 12.2605 2.11605C12.1814 2.07002 12.0915 2.04578 11.9999 2.04578C11.9084 2.04578 11.8184 2.07002 11.7393 2.11605C11.6601 2.16207 11.5946 2.22824 11.5493 2.30782L8.81061 8.12099C8.78687 8.17446 8.75035 8.22129 8.70428 8.25735C8.65821 8.29341 8.60398 8.31761 8.54637 8.32781L2.42322 9.26017C2.3326 9.27397 2.24756 9.31251 2.17743 9.37153C2.1073 9.43055 2.05481 9.50777 2.02573 9.5947C1.99666 9.68162 1.99212 9.77488 2.01263 9.86422C2.03313 9.95356 2.07788 10.0355 2.14195 10.1011L6.57264 14.6257C6.61766 14.673 6.65097 14.7302 6.66989 14.7928C6.68882 14.8553 6.69284 14.9214 6.68164 14.9858L5.6354 21.3746C5.62376 21.4459 5.62777 21.5189 5.64714 21.5886C5.6665 21.6582 5.70077 21.7228 5.74757 21.7778C5.79436 21.8329 5.85256 21.8772 5.91815 21.9075C5.98373 21.9379 6.05513 21.9536 6.1274 21.9537C6.21153 21.9538 6.2943 21.9324 6.36779 21.8914L11.8437 18.8753C11.8914 18.8488 11.945 18.8348 11.9996 18.8347C12.0541 18.8345 12.1078 18.8481 12.1557 18.8743L17.6321 21.8914C17.714 21.9365 17.8069 21.9577 17.9002 21.9526C17.9936 21.9474 18.0836 21.9161 18.16 21.8622C18.2364 21.8083 18.2961 21.734 18.3323 21.6477C18.3684 21.5615 18.3796 21.4668 18.3645 21.3746L17.3182 14.9847C17.3071 14.9205 17.3111 14.8545 17.3302 14.7921C17.3492 14.7298 17.3826 14.6727 17.4277 14.6256L21.8579 10.101C21.922 10.0355 21.9667 9.95353 21.9872 9.86419C22.0077 9.77485 22.0032 9.68159 21.9741 9.59467C21.945 9.50774 21.8926 9.43052 21.8224 9.3715C21.7523 9.31248 21.6673 9.27394 21.5766 9.26014L21.5766 9.26017ZM16.7158 13.9283C16.5614 14.0874 16.4464 14.2804 16.3803 14.492C16.3141 14.7035 16.2985 14.9277 16.3348 15.1463L17.2151 20.524L12.6359 18.0013C12.441 17.8939 12.2221 17.8377 11.9995 17.8379C11.777 17.838 11.5581 17.8946 11.3634 18.0023L6.7848 20.524L7.66559 15.1463C7.70161 14.9278 7.68596 14.7038 7.61988 14.4924C7.5538 14.281 7.43913 14.088 7.28505 13.9288L3.53466 10.0986L8.69674 9.31273C8.91611 9.27812 9.12356 9.18994 9.30071 9.05599C9.47786 8.92205 9.61923 8.74648 9.71231 8.54484L11.9999 3.68934L14.2875 8.54534C14.3809 8.74693 14.5224 8.92242 14.6998 9.05627C14.8771 9.19012 15.0846 9.2782 15.3041 9.31274L20.4652 10.0986L16.7158 13.9283Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                      <div
                        style={{ boxSizing: "border-box", maxWidth: "370px" }}
                      >
                        <h3
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 4px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Partez cet été
                        </h3>
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Offre valable pour des voyages du 01/07/24 au 31/08/24
                          inclus
                        </p>
                      </div>
                    </li>
                    <li
                      style={{
                        boxSizing: "border-box",
                        gridArea: "content4",
                        alignSelf: "start",
                        display: "flex",
                        flexFlow: "row nowrap",
                        margin: "0px 0px 24px",
                        padding: "0px",
                      }}
                    >
                      <div style={{ boxSizing: "border-box" }}>
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          data-test="iconAvantages"
                          style={{
                            boxSizing: "border-box",
                            marginRight: "16px",
                            height: "20px",
                            width: "20px",
                          }}
                        >
                          <path
                            d="M21.5766 9.26017L15.4544 8.32781C15.3966 8.31763 15.3421 8.29341 15.2958 8.25727C15.2494 8.22112 15.2127 8.17416 15.1887 8.12051L12.4505 2.30782C12.4052 2.22824 12.3397 2.16207 12.2605 2.11605C12.1814 2.07002 12.0915 2.04578 11.9999 2.04578C11.9084 2.04578 11.8184 2.07002 11.7393 2.11605C11.6601 2.16207 11.5946 2.22824 11.5493 2.30782L8.81061 8.12099C8.78687 8.17446 8.75035 8.22129 8.70428 8.25735C8.65821 8.29341 8.60398 8.31761 8.54637 8.32781L2.42322 9.26017C2.3326 9.27397 2.24756 9.31251 2.17743 9.37153C2.1073 9.43055 2.05481 9.50777 2.02573 9.5947C1.99666 9.68162 1.99212 9.77488 2.01263 9.86422C2.03313 9.95356 2.07788 10.0355 2.14195 10.1011L6.57264 14.6257C6.61766 14.673 6.65097 14.7302 6.66989 14.7928C6.68882 14.8553 6.69284 14.9214 6.68164 14.9858L5.6354 21.3746C5.62376 21.4459 5.62777 21.5189 5.64714 21.5886C5.6665 21.6582 5.70077 21.7228 5.74757 21.7778C5.79436 21.8329 5.85256 21.8772 5.91815 21.9075C5.98373 21.9379 6.05513 21.9536 6.1274 21.9537C6.21153 21.9538 6.2943 21.9324 6.36779 21.8914L11.8437 18.8753C11.8914 18.8488 11.945 18.8348 11.9996 18.8347C12.0541 18.8345 12.1078 18.8481 12.1557 18.8743L17.6321 21.8914C17.714 21.9365 17.8069 21.9577 17.9002 21.9526C17.9936 21.9474 18.0836 21.9161 18.16 21.8622C18.2364 21.8083 18.2961 21.734 18.3323 21.6477C18.3684 21.5615 18.3796 21.4668 18.3645 21.3746L17.3182 14.9847C17.3071 14.9205 17.3111 14.8545 17.3302 14.7921C17.3492 14.7298 17.3826 14.6727 17.4277 14.6256L21.8579 10.101C21.922 10.0355 21.9667 9.95353 21.9872 9.86419C22.0077 9.77485 22.0032 9.68159 21.9741 9.59467C21.945 9.50774 21.8926 9.43052 21.8224 9.3715C21.7523 9.31248 21.6673 9.27394 21.5766 9.26014L21.5766 9.26017ZM16.7158 13.9283C16.5614 14.0874 16.4464 14.2804 16.3803 14.492C16.3141 14.7035 16.2985 14.9277 16.3348 15.1463L17.2151 20.524L12.6359 18.0013C12.441 17.8939 12.2221 17.8377 11.9995 17.8379C11.777 17.838 11.5581 17.8946 11.3634 18.0023L6.7848 20.524L7.66559 15.1463C7.70161 14.9278 7.68596 14.7038 7.61988 14.4924C7.5538 14.281 7.43913 14.088 7.28505 13.9288L3.53466 10.0986L8.69674 9.31273C8.91611 9.27812 9.12356 9.18994 9.30071 9.05599C9.47786 8.92205 9.61923 8.74648 9.71231 8.54484L11.9999 3.68934L14.2875 8.54534C14.3809 8.74693 14.5224 8.92242 14.6998 9.05627C14.8771 9.19012 15.0846 9.2782 15.3041 9.31274L20.4652 10.0986L16.7158 13.9283Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                      <div
                        style={{ boxSizing: "border-box", maxWidth: "370px" }}
                      >
                        <h3
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 4px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Jusqu'à 6 billets en cours
                        </h3>
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Réservez des billets supplémentaires dès que votre
                          compteur est inférieur à 6 voyages en cours
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  margin: "0px -16px 48px",
                }}
              >
                <h2
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0px 24px",
                    fontFamily: "Avenir",
                    fontSize: "20px",
                    lineHeight: "26px",
                    fontWeight: 800,
                    padding: "0px 16px",
                  }}
                >
                  Quelques informations complémentaires
                </h2>
                <div
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      height: "214px",
                      position: "relative",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "block",
                        boxSizing: "border-box",
                        height: "214px",
                        width: "100%",
                      }}
                    >
                      <img
                        alt=""
                        src="https://www.sncf-connect.com/assets/styles/scale_and_crop_380x214/public/media/2022-01/crea-generique-offres-1.png?itok=eI5CPMcn"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          objectFit: "cover",
                          objectPosition: "50% 50%",
                          height: "214px",
                          width: "100%",
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "none",
                        boxSizing: "border-box",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <img
                        alt=""
                        src="https://www.sncf-connect.com/assets/styles/scale_and_crop_1275x256/public/media/2022-01/crea-generique-offres-1.png?itok=a0R3fld1"
                        style={{
                          boxSizing: "border-box",
                          borderStyle: "none",
                          objectFit: "cover",
                          objectPosition: "50% 50%",
                          height: "100%",
                          width: "100%",
                        }}
                      />
                    </div>
                  </div>
                  <ul
                    role="list"
                    style={{
                      boxSizing: "border-box",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      WebkitBoxPack: "center",
                      justifyContent: "center",
                      listStyle: "outside none none",
                      margin: "-88px 0px 0px",
                      padding: "0px 16px",
                      zIndex: 1,
                    }}
                  >
                    <li
                      style={{
                        boxSizing: "border-box",
                        marginBottom: "16px",
                        maxWidth: "328px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          color: "rgb(12, 19, 31)",
                          transition:
                            "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          borderRadius: "14px",
                          overflow: "hidden",
                          boxShadow: "none",
                          border: "0px none rgb(12, 19, 31)",
                          background:
                            "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                          WebkitBoxAlign: "stretch",
                          alignItems: "stretch",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            paddingBottom: "32px",
                            display: "flex",
                            flexDirection: "column",
                            WebkitBoxPack: "justify",
                            justifyContent: "space-between",
                            minHeight: "262px",
                            padding: "24px 16px 32px",
                          }}
                        >
                          <div style={{ boxSizing: "border-box" }}>
                            <h3
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                                paddingBottom: "4px",
                              }}
                            >
                              INTERCITÉS
                            </h3>
                            <p
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                                color: "rgb(94, 104, 120)",
                                whiteSpace: "pre-line",
                              }}
                            >
- Billets à 0 € en 2nde classe sur les INTERCITÉS de jour et INTERCITÉS de nuit (place assise uniquement)

- Billets à 19,50 € en couchette 2nde classe sur les INTERCITÉS de nuit

- Annulation gratuite jusqu'au départ du train
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      style={{
                        boxSizing: "border-box",
                        marginBottom: "16px",
                        maxWidth: "328px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          color: "rgb(12, 19, 31)",
                          transition:
                            "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          borderRadius: "14px",
                          overflow: "hidden",
                          boxShadow: "none",
                          border: "0px none rgb(12, 19, 31)",
                          background:
                            "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                          WebkitBoxAlign: "stretch",
                          alignItems: "stretch",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            paddingBottom: "32px",
                            display: "flex",
                            flexDirection: "column",
                            WebkitBoxPack: "justify",
                            justifyContent: "space-between",
                            minHeight: "262px",
                            padding: "24px 16px 32px",
                          }}
                        >
                          <div style={{ boxSizing: "border-box" }}>
                            <h3
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                                paddingBottom: "4px",
                              }}
                            >
                              Trains Régionaux
                            </h3>
                            <p
                              style={{
                                boxSizing: "border-box",
                                margin: "0px",
                                fontFamily:
                                  "Avenir",
                                fontSize: "16px",
                                lineHeight: "22px",
                                fontWeight: 500,
                                color: "rgb(94, 104, 120)",
                                whiteSpace: "pre-line",
                              }}
                            >
                              - Billets à 0 € en 2nde classe sur les Trains
                              Régionaux (hors parcours Ile-de-France et TERGV) -
                              Annulation gratuite jusqu'au départ du train sur
                              les Trains Régionaux avec réservation obligatoire
                              (Régions Normandie et Grand Est) - Annulation
                              gratuite jusqu'à J-1 du départ sur les Trains
                              Régionaux sans réservation
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  margin: "32px 0px 24px",
                }}
              >
                <h2
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0px 24px",
                    fontFamily: "Avenir",
                    fontSize: "20px",
                    lineHeight: "26px",
                    fontWeight: 800,
                    padding: "0px 16px",
                  }}
                >
                  Comment profiter du Pass Rail ?
                </h2>
                <ol
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    margin: "0px 0px 16px",
                    padding: "0px",
                  }}
                >
                  <li style={{ boxSizing: "border-box", overflow: "hidden" }}>
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        marginBottom: "24px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        data-test="icon-1"
                        style={{
                          boxSizing: "border-box",
                          fill: "rgb(12, 19, 31)",
                          marginBottom: "16px",
                          height: "70px",
                          width: "4.375rem",
                        }}
                      >
                        <path
                          d="M12 2C6.49434 2 2 6.49438 2 12C2 17.5056 6.49434 22 12 22C17.5056 22 22 17.5056 22 12C22 6.49438 17.5056 2 12 2ZM12 20.8764C7.11232 20.8764 3.1236 16.8876 3.1236 12C3.1236 7.11236 7.11232 3.1236 12 3.1236C16.8876 3.1236 20.8764 7.11236 20.8764 12C20.8764 16.8876 16.8876 20.8764 12 20.8764Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M11.9194 10.2786L10.5161 11.1811L10 10.3203L12.1129 9H13V15H11.9194V10.2786Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px 0px 4px",
                          fontFamily:
                            "Avenir",
                          fontSize: "18px",
                          lineHeight: "24px",
                          fontWeight: 800,
                        }}
                      >
                        Achetez
                      </p>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          fontFamily:
                            "Avenir",
                          fontSize: "16px",
                          lineHeight: "22px",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        dès maintenant votre Pass Rail sur SNCF Connect
                      </p>
                    </div>
                  </li>
                  <li style={{ boxSizing: "border-box", overflow: "hidden" }}>
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        marginBottom: "24px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        data-test="icon-2"
                        style={{
                          boxSizing: "border-box",
                          fill: "rgb(12, 19, 31)",
                          marginBottom: "16px",
                          height: "70px",
                          width: "4.375rem",
                        }}
                      >
                        <path
                          d="M12 2C6.49434 2 2 6.49438 2 12C2 17.5056 6.49434 22 12 22C17.5056 22 22 17.5056 22 12C22 6.49438 17.5056 2 12 2ZM12 20.8764C7.11232 20.8764 3.1236 16.8876 3.1236 12C3.1236 7.11236 7.11232 3.1236 12 3.1236C16.8876 3.1236 20.8764 7.11236 20.8764 12C20.8764 16.8876 16.8876 20.8764 12 20.8764Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M10 15V14.4493C10 14.1753 10.0342 13.9288 10.1026 13.7096C10.1709 13.4904 10.2678 13.2904 10.3932 13.1096C10.5185 12.9288 10.6695 12.7616 10.8462 12.6082C11.0285 12.4548 11.2336 12.3041 11.4615 12.1562L11.9316 11.8603C12.0684 11.7671 12.1909 11.6849 12.2991 11.6137C12.4131 11.5425 12.5071 11.4658 12.5812 11.3836C12.661 11.3014 12.7208 11.2082 12.7607 11.1041C12.8063 10.9945 12.8291 10.863 12.8291 10.7096C12.8291 10.1507 12.5328 9.87123 11.9402 9.87123C11.661 9.87123 11.4188 9.93151 11.2137 10.0521C11.0085 10.1726 10.8148 10.3068 10.6325 10.4548L10.1197 9.60822C10.4729 9.38356 10.8063 9.2274 11.1197 9.13973C11.433 9.04658 11.7635 9 12.1111 9C12.6752 9 13.1254 9.14247 13.4615 9.4274C13.8034 9.71233 13.9744 10.137 13.9744 10.7014C13.9744 10.9479 13.9316 11.1616 13.8462 11.3425C13.7607 11.5233 13.6467 11.6849 13.5043 11.8274C13.3675 11.9699 13.2108 12.0986 13.0342 12.2137C12.8632 12.3288 12.6895 12.4438 12.5128 12.5589L11.9487 12.9288C11.6695 13.1041 11.4587 13.2877 11.3162 13.4795C11.1795 13.6658 11.0997 13.8548 11.0769 14.0466H14V15H10Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px 0px 4px",
                          fontFamily:
                            "Avenir",
                          fontSize: "18px",
                          lineHeight: "24px",
                          fontWeight: 800,
                        }}
                      >
                        Choisissez
                      </p>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          fontFamily:
                            "Avenir",
                          fontSize: "16px",
                          lineHeight: "22px",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        la date de début de validité de votre pass (entre le
                        01/07/24 et le 31/08/24)
                      </p>
                    </div>
                  </li>
                  <li style={{ boxSizing: "border-box", overflow: "hidden" }}>
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        marginBottom: "24px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        data-test="icon-3"
                        style={{
                          boxSizing: "border-box",
                          fill: "rgb(12, 19, 31)",
                          marginBottom: "16px",
                          height: "70px",
                          width: "4.375rem",
                        }}
                      >
                        <path
                          d="M12 2C6.49434 2 2 6.49438 2 12C2 17.5056 6.49434 22 12 22C17.5056 22 22 17.5056 22 12C22 6.49438 17.5056 2 12 2ZM12 20.8764C7.11232 20.8764 3.1236 16.8876 3.1236 12C3.1236 7.11236 7.11232 3.1236 12 3.1236C16.8876 3.1236 20.8764 7.11236 20.8764 12C20.8764 16.8876 16.8876 20.8764 12 20.8764Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M14 13.0997C14 13.3962 13.9471 13.6631 13.8413 13.9003C13.7354 14.1321 13.5873 14.3315 13.3968 14.4987C13.2116 14.6604 12.9894 14.7844 12.7302 14.8706C12.4762 14.9569 12.1984 15 11.8968 15C11.4841 15 11.1217 14.9191 10.8095 14.7574C10.5026 14.5957 10.2328 14.3288 10 13.9569L10.7857 13.3585C10.9074 13.5957 11.0503 13.7898 11.2143 13.9407C11.3836 14.0863 11.6217 14.159 11.9286 14.159C12.2566 14.159 12.5079 14.0674 12.6825 13.8841C12.8624 13.6954 12.9524 13.4528 12.9524 13.1563C12.9524 12.8491 12.8571 12.6253 12.6667 12.4852C12.4815 12.3396 12.2381 12.2668 11.9365 12.2668C11.7037 12.2668 11.5079 12.283 11.3492 12.3154V11.4178H11.6111C11.7328 11.4178 11.8492 11.4151 11.9603 11.4097C12.0767 11.3989 12.1852 11.3747 12.2857 11.3369C12.418 11.2884 12.5238 11.2049 12.6032 11.0863C12.6825 10.9677 12.7222 10.7978 12.7222 10.5768C12.7222 10.3396 12.6455 10.159 12.4921 10.035C12.3439 9.90566 12.1402 9.84097 11.881 9.84097C11.7487 9.84097 11.6243 9.85714 11.5079 9.88949C11.3968 9.92183 11.2937 9.96496 11.1984 10.0189C11.1032 10.0674 11.0159 10.124 10.9365 10.1887C10.8624 10.248 10.7937 10.3046 10.7302 10.3585L10.2619 9.54986C10.5317 9.37197 10.8095 9.2372 11.0952 9.14555C11.3862 9.04852 11.6931 9 12.0159 9C12.254 9 12.4762 9.02965 12.6825 9.08895C12.8942 9.14286 13.0794 9.23181 13.2381 9.35579C13.3968 9.47439 13.5212 9.62534 13.6111 9.80863C13.7063 9.98652 13.754 10.2022 13.754 10.4555C13.754 10.6065 13.7302 10.7466 13.6825 10.876C13.6349 11 13.5714 11.1132 13.4921 11.2156C13.4127 11.3181 13.3201 11.407 13.2143 11.4825C13.1138 11.558 13.0079 11.6199 12.8968 11.6685V11.6927C13.0344 11.7197 13.1667 11.7709 13.2937 11.8464C13.4259 11.9164 13.545 12.0108 13.6508 12.1294C13.7566 12.2426 13.8413 12.3801 13.9048 12.5418C13.9683 12.7035 14 12.8895 14 13.0997Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px 0px 4px",
                          fontFamily:
                            "Avenir",
                          fontSize: "18px",
                          lineHeight: "24px",
                          fontWeight: 800,
                        }}
                      >
                        Réservez votre billet
                      </p>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          fontFamily:
                            "Avenir",
                          fontSize: "16px",
                          lineHeight: "22px",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        via le site web ou l'application mobile SNCF Connect
                      </p>
                    </div>
                  </li>
                  <li style={{ boxSizing: "border-box", overflow: "hidden" }}>
                    <div
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        marginBottom: "24px",
                      }}
                    >
                      <svg
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        data-test="icon-4"
                        style={{
                          boxSizing: "border-box",
                          fill: "rgb(12, 19, 31)",
                          marginBottom: "16px",
                          height: "70px",
                          width: "4.375rem",
                        }}
                      >
                        <path
                          d="M12 2C6.49434 2 2 6.49438 2 12C2 17.5056 6.49434 22 12 22C17.5056 22 22 17.5056 22 12C22 6.49438 17.5056 2 12 2ZM12 20.8764C7.11232 20.8764 3.1236 16.8876 3.1236 12C3.1236 7.11236 7.11232 3.1236 12 3.1236C16.8876 3.1236 20.8764 7.11236 20.8764 12C20.8764 16.8876 16.8876 20.8764 12 20.8764Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                        <path
                          d="M12.4264 9.96266L10.8527 12.8091H12.4264V9.96266ZM13.4031 13.7801V15H12.4264V13.7801H10V12.7261L12.1318 9H13.4031V12.7925H14V13.7801H13.4031Z"
                          style={{ boxSizing: "border-box" }}
                        ></path>
                      </svg>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px 0px 4px",
                          fontFamily:
                            "Avenir",
                          fontSize: "18px",
                          lineHeight: "24px",
                          fontWeight: 800,
                        }}
                      >
                        Voyagez
                      </p>
                      <p
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          fontFamily:
                            "Avenir",
                          fontSize: "16px",
                          lineHeight: "22px",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        équipé de votre e-billet, Pass Rail et pièce d'identité
                      </p>
                    </div>
                  </li>
                </ol>
              </div>
              <div style={{ boxSizing: "border-box" }}>
                <div
                  style={{
                    boxSizing: "border-box",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    marginBottom: "24px",
                    maxWidth: "628px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      color: "rgb(12, 19, 31)",
                      transition:
                        "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      borderRadius: "14px",
                      overflow: "hidden",
                      boxShadow: "none",
                      border: "0px none rgb(12, 19, 31)",
                      background:
                        "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                      maxWidth: "328px",
                      height: "306px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        boxSizing: "border-box",
                        paddingBottom: "16px",
                        padding: "16px",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "justify",
                        justifyContent: "space-between",
                        minHeight: "265px",
                      }}
                    >
                      <div style={{ boxSizing: "border-box" }}>
                        <h3
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 16px",
                            fontFamily:
                              "Avenir",
                            fontSize: "18px",
                            lineHeight: "24px",
                            fontWeight: 800,
                          }}
                        >
                          Bon à savoir
                        </h3>
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Pour bénéficier des tarifs du Pass Rail sur vos
                          trajets TER &amp; Intercités, pensez à décocher votre
                          Carte Avantage Jeune ou abonnement régional de votre
                          Profil voyageur avant de lancer votre recherche.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    boxSizing: "border-box",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    marginBottom: "24px",
                    maxWidth: "628px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      color: "rgb(12, 19, 31)",
                      transition:
                        "box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      borderRadius: "14px",
                      overflow: "hidden",
                      boxShadow: "none",
                      border: "0px none rgb(12, 19, 31)",
                      background:
                        "rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box border-box",
                      maxWidth: "328px",
                      height: "265px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        boxSizing: "border-box",
                        paddingBottom: "16px",
                        padding: "16px",
                        display: "flex",
                        flexDirection: "column",
                        WebkitBoxPack: "justify",
                        justifyContent: "space-between",
                        minHeight: "265px",
                      }}
                    >
                      <div style={{ boxSizing: "border-box" }}>
                        <h3
                          style={{
                            boxSizing: "border-box",
                            margin: "0px 0px 16px",
                            fontFamily:
                              "Avenir",
                            fontSize: "18px",
                            lineHeight: "24px",
                            fontWeight: 800,
                          }}
                        >
                          Vous fêtez vos 28 ans cet été ?
                        </h3>
                        <p
                          style={{
                            boxSizing: "border-box",
                            margin: "0px",
                            fontFamily:
                              "Avenir",
                            fontSize: "16px",
                            lineHeight: "22px",
                            fontWeight: 500,
                          }}
                        >
                          Profitez du Pass Rail jusqu'à la veille de vos 28 ans
                          ! Exemple : je fête mes 28 ans le 20/07/2024, j'achète
                          mon pass à 2,45 €, je choisis le 01/07/24 comme date
                          d'activation et je profite de mes voyages jusqu'au
                          19/07/24 inclus.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr
              aria-hidden="true"
              style={{
                boxSizing: "content-box",
                height: "8px",
                overflow: "visible",
                margin: "0px",
                flexShrink: 0,
                borderWidth: "0px",
                borderColor: "rgb(173, 255, 47)",
                backgroundColor: "rgb(255, 255, 255)",
                borderStyle: "none",
              }}
            />
            <div
              style={{
                boxSizing: "border-box",
                marginBottom: "24px",
                paddingTop: "32px",
              }}
            >
              <h2
                style={{
                  boxSizing: "border-box",
                  margin: "0px 0px 16px",
                  fontFamily: "Avenir",
                  fontSize: "18px",
                  lineHeight: "24px",
                  fontWeight: 800,
                }}
              >
                Toutes les réponses à vos questions sur le Pass Rail
              </h2>
              <ul
                data-test="description_wrapper"
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  listStyle: "outside none none",
                  margin: "0px",
                  padding: "0px",
                }}
              >
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    tabIndex={0}
                    data-test="description_question_0"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      aria-controls="description_question_0-content"
                      data-test="description_question_0_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontSize: "16px",
                              lineHeight: "22px",
                              fontWeight: 500,
                            }}
                          >
                            Comment consulter les trajets réservés ?
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_0-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              data-test="description_question_0_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                data-test="description_details_content_0"
                                style={{
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                Si vous avez un compte client Connect, vous
                                pourrez consulter les trajets réservés. Lors du
                                parcours de réservation, une fois que vous aurez
                                atteint 6 réservations simultanées, un message
                                vous indiquera "Vous avez déjà 6 réservations en
                                cours". Pour faire une autre réservation ,
                                annuler un de ces voyages depuis votre compte.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr
                    aria-hidden="true"
                    style={{
                      boxSizing: "content-box",
                      height: "1px",
                      overflow: "visible",
                      margin: "0px",
                      flexShrink: 0,
                      borderWidth: "0px 0px 1px",
                      borderStyle: "solid",
                      borderColor: "rgb(132, 139, 155)",
                    }}
                  />
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    tabIndex={0}
                    data-test="description_question_1"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      aria-controls="description_question_1-content"
                      data-test="description_question_1_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontSize: "16px",
                              lineHeight: "22px",
                              fontWeight: 500,
                            }}
                          >
                            Jusqu'à quel âge puis-je bénéficier du Pass Rail ?
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_1-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              data-test="description_question_1_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                data-test="description_details_content_1"
                                style={{
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                Le Pass Rail est accessible aux jeunes de 16 à
                                27 ans inclus : souscription, validité et
                                utilisation possibles jusqu'à la veille du 28ème
                                anniversaire.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr
                    aria-hidden="true"
                    style={{
                      boxSizing: "content-box",
                      height: "1px",
                      overflow: "visible",
                      margin: "0px",
                      flexShrink: 0,
                      borderWidth: "0px 0px 1px",
                      borderStyle: "solid",
                      borderColor: "rgb(132, 139, 155)",
                    }}
                  />
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    tabIndex={0}
                    data-test="description_question_2"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      aria-controls="description_question_2-content"
                      data-test="description_question_2_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontSize: "16px",
                              lineHeight: "22px",
                              fontWeight: 500,
                            }}
                          >
                            Si j'achète un Pass Rail dans le courant du mois
                            d'août 2024, sera-t-il valable au-delà du 31 août
                            2024 ? Et si je fête mes 28 ans pendant la validité
                            du Pass Rail ?
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_2-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              data-test="description_question_2_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                data-test="description_details_content_2"
                                style={{
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                Le Pass Rail est valable pour une durée de 31
                                jours consécutifs maximum à partir de la date de
                                validité choisir par le titulaire au moment de
                                l'achat, entre le 1er juillet et le 31 août 2024
                                au plus tard, ou jusqu'à la veille de son 28ème
                                anniversaire, si celui-ci survient plus tôt. Le
                                prix est fixe, à 2,45 €, même si la durée
                                d'utilisation est inférieure à 31 jours.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr
                    aria-hidden="true"
                    style={{
                      boxSizing: "content-box",
                      height: "1px",
                      overflow: "visible",
                      margin: "0px",
                      flexShrink: 0,
                      borderWidth: "0px 0px 1px",
                      borderStyle: "solid",
                      borderColor: "rgb(132, 139, 155)",
                    }}
                  />
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    tabIndex={0}
                    data-test="description_question_3"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      aria-controls="description_question_3-content"
                      data-test="description_question_3_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontSize: "16px",
                              lineHeight: "22px",
                              fontWeight: 500,
                            }}
                          >
                            Est-il possible d'acheter le Pass Rail si je fête
                            mes 16 ans cet été ?
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_3-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              data-test="description_question_3_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                data-test="description_details_content_3"
                                style={{
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                Si je n'ai pas encore 16 ans au moment de
                                l'achat, la validité du Pass Rail ne pourra
                                commencer qu'à partir du jour de mon 16ème
                                anniversaire, pour 31 jours consécutifs,
                                jusqu'au 31 août 2024 au plus tard.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr
                    aria-hidden="true"
                    style={{
                      boxSizing: "content-box",
                      height: "1px",
                      overflow: "visible",
                      margin: "0px",
                      flexShrink: 0,
                      borderWidth: "0px 0px 1px",
                      borderStyle: "solid",
                      borderColor: "rgb(132, 139, 155)",
                    }}
                  />
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    tabIndex={0}
                    data-test="description_question_4"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      aria-controls="description_question_4-content"
                      data-test="description_question_4_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontSize: "16px",
                              lineHeight: "22px",
                              fontWeight: 500,
                            }}
                          >
                            Le Pass Rail est-il valable immédiatement après
                            l'achat ?
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_4-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              data-test="description_question_4_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                data-test="description_details_content_4"
                                style={{
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                Le Pass Rail est mis en vente à partir du 5 juin
                                2024, et utilisable pour 31 jours à partir de la
                                date de validité choisir, entre le 1er juillet
                                2024 et le 31 août 2024 au plus tard. Les
                                billets pourront être pris à partir du 5 juin
                                2024 pour des voyages entre le 1er juillet 2024
                                et le 31 août 2024 inclus. Si le titulaire n'a
                                pas atteint l'âge de 16 ans au moment de
                                l'achat, le premier jour de validité du Pass
                                Rail ne pourra être qu'au plus tôt le jour de
                                ses 16 ans.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr
                    aria-hidden="true"
                    style={{
                      boxSizing: "content-box",
                      height: "1px",
                      overflow: "visible",
                      margin: "0px",
                      flexShrink: 0,
                      borderWidth: "0px 0px 1px",
                      borderStyle: "solid",
                      borderColor: "rgb(132, 139, 155)",
                    }}
                  />
                </li>
                <li style={{ boxSizing: "border-box" }}>
                  <div
                    tabIndex={0}
                    data-test="description_question_5"
                    style={{
                      boxSizing: "border-box",
                      borderBottomLeftRadius: "14px",
                      borderBottomRightRadius: "14px",
                      borderTopLeftRadius: "14px",
                      borderTopRightRadius: "14px",
                      color: "rgb(12, 19, 31)",
                      boxShadow: "none",
                      position: "relative",
                      transition:
                        "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                      overflowAnchor: "none",
                      borderRadius: "14px",
                      background:
                        "rgb(243, 243, 248) none repeat scroll 0% 0% / auto padding-box border-box",
                    }}
                  >
                    <div
                      tabIndex={0}
                      role="button"
                      aria-expanded="false"
                      aria-controls="description_question_5-content"
                      data-test="description_question_5_summary"
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxAlign: "center",
                        alignItems: "center",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        position: "relative",
                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                        backgroundColor: "rgba(0, 0, 0, 0)",
                        outline: "rgb(12, 19, 31) none 0px",
                        border: "0px none rgb(12, 19, 31)",
                        margin: "0px",
                        borderRadius: "0px",
                        cursor: "pointer",
                        userSelect: "none",
                        verticalAlign: "middle",
                        appearance: "none",
                        textDecoration: "none solid rgb(12, 19, 31)",
                        color: "rgb(12, 19, 31)",
                        display: "flex",
                        transition:
                          "min-height 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s, background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        minHeight: "56px",
                        padding: "16px 0px",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          WebkitBoxFlex: 1,
                          flexGrow: 1,
                          transition:
                            "margin 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          margin: "0px",
                        }}
                      >
                        <div
                          style={{
                            boxSizing: "border-box",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            WebkitBoxFlex: 1,
                            flexGrow: 1,
                            width: "calc(100% - 34px)",
                          }}
                        >
                          <p
                            style={{
                              boxSizing: "border-box",
                              margin: "0px",
                              fontFamily:
                                "Avenir",
                              fontSize: "16px",
                              lineHeight: "22px",
                              fontWeight: 500,
                            }}
                          >
                            Je dispose d’une Carte Avantage jeune, comment
                            bénéficier des réductions associées à ma carte
                            Avantage, ainsi que celle du Pass Rail ?
                          </p>
                        </div>
                      </div>
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          color: "rgb(12, 19, 31)",
                          transform: "matrix(1, 0, 0, 1, 0, 0)",
                          transition:
                            "transform 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                          marginRight: "-16px",
                          padding: "0px 16px",
                        }}
                      >
                        <svg
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            boxSizing: "border-box",
                            height: "24px",
                            width: "1.5rem",
                            color: "rgb(20, 112, 138)",
                            display: "block",
                            fill: "rgb(20, 112, 138)",
                            flexShrink: 0,
                            fontSize: "24px",
                            transition:
                              "fill 0.2s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            userSelect: "none",
                          }}
                        >
                          <path
                            d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                            style={{ boxSizing: "border-box" }}
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <div
                      style={{
                        minHeight: "0px",
                        boxSizing: "border-box",
                        height: "0px",
                        overflow: "hidden",
                        transition:
                          "height 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                        visibility: "hidden",
                      }}
                    >
                      <div
                        style={{
                          boxSizing: "border-box",
                          display: "flex",
                          width: "100%",
                        }}
                      >
                        <div style={{ boxSizing: "border-box", width: "100%" }}>
                          <div
                            aria-labelledby="description_question_5-summary"
                            role="region"
                            style={{ boxSizing: "border-box" }}
                          >
                            <div
                              data-test="description_question_5_details"
                              style={{
                                boxSizing: "border-box",
                                padding: "0px",
                                flexDirection: "column",
                              }}
                            >
                              <p
                                data-test="description_details_content_5"
                                style={{
                                  boxSizing: "border-box",
                                  margin: "0px 0px 16px",
                                  fontFamily:
                                    "Avenir",
                                  fontSize: "16px",
                                  lineHeight: "22px",
                                  fontWeight: 500,
                                  whiteSpace: "pre-line",
                                }}
                              >
                                Dans le cas d’un trajet en correspondance, vous
                                devez réaliser des achats séparés pour chacun de
                                vos trajets : - Un premier achat avec votre
                                Carte Avantage Jeune pour votre trajet TGV INOUI
                                (pour bénéficier de la réduction sur votre
                                trajet en TGV) - Une deuxième réservation en
                                cochant le profil « Pass Rail » au début de
                                votre parcours d’achat pour bénéficier de votre
                                réservation TER ou Intercités à 0€
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <hr
              aria-hidden="true"
              style={{
                boxSizing: "content-box",
                height: "8px",
                overflow: "visible",
                margin: "0px",
                flexShrink: 0,
                borderWidth: "0px",
                borderColor: "rgb(173, 255, 47)",
                backgroundColor: "rgb(255, 255, 255)",
                borderStyle: "none",
              }}
            />
            <div style={{ boxSizing: "border-box", paddingTop: "32px" }}>
              <h2
                style={{
                  boxSizing: "border-box",
                  margin: "0px 0px 16px",
                  fontFamily: "Avenir",
                  fontSize: "18px",
                  lineHeight: "24px",
                  fontWeight: 800,
                }}
              >
                Conditions générales d'utilisation
              </h2>
              <div
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  listStyle: "outside none none",
                  margin: "0px",
                  padding: "0px",
                }}
              >
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    PRIX ET VALIDITE DU PASS RAIL
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Le Pass Rail est réservé aux jeunes de 16 à 27 ans inclus :
                    souscription, validité et utilisation possibles jusqu’à la
                    veille du 28ème anniversaire. Le Pass Rail est non
                    échangeable, non remboursable. Il permet de voyager en
                    France, à bord de tous les INTERCITÉS jour, les INTERCITÉS
                    nuit et les TER* hors parcours Ile-de-France. Accès interdit
                    aux TERGV (Région Hauts-de-France). Il n’est pas valable sur
                    TGV INOUI, OUIGO Trains Classiques, OUIGO Grande Vitesse,
                    RER/Transilien en Ile-de-France, Eurostar (Transmanche et
                    Continental), et toutes les entités d’offres internationales
                    : TGV France-Bruxelles, DB-SNCF Voyageurs en coopération,
                    TGV Lyria, TGV France-Italie, TGV France-Luxembourg, TGV
                    France-Fribourg, TGV France-Espagne. Il n’est pas valable
                    sur les autres Entreprises Ferroviaires circulant en France
                    (Trenitalia et RENFE). *Le Pass est valable vers/depuis les
                    gares étrangères à taxation française (Bâle, Genève,
                    Vintimille, Vallorbe) - tous les autres parcours
                    transfrontaliers sont interdits. Prix du Pass Rail 16-27 ans
                    : 2,45 €. Durée de validité : 31 jours consécutifs maximum à
                    partir de la date de début de validité choisie par le client
                    lors de l’achat. Le Pass Rail peut être acheté dès le
                    05/06/2024 pour un début de validité au plus tôt le
                    01/07/2024. La fin de validité du Pass Rail ne peut dépasser
                    le 31/08/2024 ou la veille des 28 ans du client. 2nde classe
                    uniquement. Accès interdit en 1ère classe.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    CONDITIONS D'UTILISATION
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Le Pass Rail est délivré sous une forme dématérialisée : un
                    PDF comportant le QR code du Pass Rail est envoyé en pièce
                    jointe par email ou téléchargeable via un lien. Il est
                    nominatif, personnel et non cessible. Pour voyager, la
                    présentation du Pass Rail, d'un billet, et d'une pièce
                    d'identité officielle est obligatoire. Pièce d'identité
                    numérisée ou photocopiée non acceptée.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    ACHAT, ÉCHANGE ET ANNULATION DES BILLETS AU TARIF PASS RAIL
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Pour voyager, le Pass Rail doit obligatoirement être
                    accompagné d’un : • Billet à 0€ pour les trajets en TER sans
                    réservation, et uniquement valable dans le(s) train(s)
                    indiqué(s) sur le billet. Annulation possible jusqu’à J-1 •
                    Billet à 0 €, avec réservation d’une place assise, pour les
                    trajets en INTERCITÉS jour et nuit, et en TER avec
                    réservation obligatoire (Régions Normandie et Grand Est).
                    Echange et annulation sans frais jusqu’au départ du train. •
                    Billet à 19,50 €, avec réservation d’une place couchette, pour
                    les trajets en INTERCITÉS nuit. Echange et remboursement
                    sans frais jusqu’au départ du train. Billet nominatif,
                    personnel et incessible au format PDF avec QR code. Pour
                    obtenir son billet, le voyageur doit impérativement indiquer
                    le numéro du Pass Rail valide au moment de l’achat de son
                    voyage prévu. Le voyageur peut revendiquer son tarif soit
                    par la saisie du numéro du Pass à chaque achat, soit en se
                    connectant à son compte client dans lequel le numéro aura
                    été préalablement enregistré. A défaut, si le client n’est
                    pas en mesure de prouver qu’il détient un Pass Rail, le
                    billet ne pourra lui être accordé. Le Pass Rail permet
                    d’emprunter tous les trains éligibles dans la limite des
                    places attribuées aux titulaires Pass Rail, et à raison d’un
                    trajet par jour maximum au départ de la même ville (y
                    compris en cas de correspondance) et de six billets en cours
                    maximum pour des trajets à venir. Le client ne peut avoir
                    des billets pour 2 trains circulant simultanément.{" "}
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    PERTE OU VOL DU PASS RAIL
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    La réédition du Pass Rail au format électronique PDF est
                    effectuée gratuitement sur le site tgvinoui.sncf en se
                    connectant à son compte client ou en renseignant son nom,
                    prénom, date de naissance et l’adresse email communiquée au
                    moment de l’achat. Le Pass sera renvoyé sur l’email de son
                    titulaire.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    DROIT A LA RÉTRACTATION SUITE A L’ACHAT D’UN PASS RAIL
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Conformément aux dispositions légales en vigueur, le client
                    Pass Rail dispose d’un délai de rétractation de quatorze
                    (14) jours ouvrés à compter de la date d’achat. Si ce délai
                    expire un samedi, un dimanche ou un jour férié, il est
                    prolongé jusqu’au premier jour ouvrable. La demande du droit
                    de rétractation n’est recevable que lorsque le Pass Rail n’a
                    pas été utilisé. Si aucun voyage n’a été réalisé, le droit
                    de rétractation est accordé et le client est remboursé de
                    l’intégralité du prix payé. Tous les billets doivent être
                    annulés avant la demande de rétractation.
                  </p>
                </div>
                <div style={{ boxSizing: "border-box", marginBottom: "16px" }}>
                  <h3
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontWeight: 500,
                    }}
                  >
                    SERVICES VELOS ET ANIMAUX
                  </h3>
                  <p
                    style={{
                      boxSizing: "border-box",
                      margin: "0px",
                      fontFamily: "Avenir",
                      fontSize: "13px",
                      lineHeight: "18px",
                      fontWeight: 500,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Sur le périmètre INTERCITÉS, les services liés au transport
                    de vélos et d’animaux sont accessibles aux titulaires du
                    Pass Rail au même titre qu’un billet classique : • Pour le
                    transport de vélos, l’ensemble des règles applicables figure
                    dans les Tarifs Voyageurs SNCF (Volume 1, chapitre 11),
                    consultables sur www.sncf-voyageurs.com – Tarifs Voyageurs •
                    Pour le transport de chiens et de petits animaux domestiques
                    accompagnant les voyageurs, l’ensemble des règles
                    applicables figure dans les Tarifs Voyageurs SNCF (Volume 5,
                    chapitre 3), consultables sur www.sncf-voyageurs.com –
                    Tarifs Voyageurs Sur le périmètre TER, le transport d’un
                    vélo et des animaux sont soumis à des conditions
                    particulières. Avant de voyager, le titulaire du Pass Rail
                    doit se renseigner sur les sites Internet TER régionaux
                    (https://www.sncf-voyageurs.com/fr/voyagez-avec-nous/en-france/ter/carte-ter/)
                    Les Conditions Générales d’Utilisation et la Politique de
                    Confidentialité du Pass Rail sont consultables sur ce lien :
                    https://www.sncf-voyageurs.com/medias-publics/2024-04/pass-rail-cgu-politique-confidentialite.pdf
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
